"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "parma": {
    "1d2784a1": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "baganzolino": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e9cfb41": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "barilla-center-v-le-fratti": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "f0f3f932": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "case-vecchie": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24a328e9": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3c4e80b1": [{
      "hkey": "a0d03b4e",
      "slug": "baganzola-cervara",
      "name": "Baganzola-Cervara",
      "primary": true,
      "skipSearch": false
    }],
    "cervara": [{
      "hkey": "a0d03b4e",
      "slug": "baganzola-cervara",
      "name": "Baganzola-Cervara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3930fbfb": [{
      "hkey": "8422c803",
      "slug": "cittadella-mariano-montebello",
      "name": "Cittadella-Mariano-Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "cittadella": [{
      "hkey": "8422c803",
      "slug": "cittadella-mariano-montebello",
      "name": "Cittadella-Mariano-Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8265d5bf": [{
      "hkey": "27ac2072",
      "slug": "cortile-san-martino",
      "name": "Cortile San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "cortile-san-martino-moletolo": [{
      "hkey": "27ac2072",
      "slug": "cortile-san-martino",
      "name": "Cortile San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2b77fbb9": [{
      "hkey": "49782f8d",
      "slug": "crocetta",
      "name": "Crocetta",
      "primary": true,
      "skipSearch": false
    }],
    "crocetta-s-pancrazio": [{
      "hkey": "49782f8d",
      "slug": "crocetta",
      "name": "Crocetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f1d0e33e": [{
      "hkey": "28c18555",
      "slug": "fognano-aeroporto-g-verdi",
      "name": "Fognano-Aeroporto G.Verdi",
      "primary": true,
      "skipSearch": false
    }],
    "fognano": [{
      "hkey": "28c18555",
      "slug": "fognano-aeroporto-g-verdi",
      "name": "Fognano-Aeroporto G.Verdi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "543b7d96": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "fraore": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c2ad3415": [{
      "hkey": "a0d03b4e",
      "slug": "baganzola-cervara",
      "name": "Baganzola-Cervara",
      "primary": true,
      "skipSearch": false
    }],
    "golese-baganzola": [{
      "hkey": "a0d03b4e",
      "slug": "baganzola-cervara",
      "name": "Baganzola-Cervara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "f992cd7f": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "skipSearch": false
    }],
    "lubiana": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "5a9ff3f1": [{
      "hkey": "3d1feb0b",
      "slug": "molinetto",
      "name": "Molinetto",
      "primary": true,
      "skipSearch": false
    }],
    "molinetto-palasport": [{
      "hkey": "3d1feb0b",
      "slug": "molinetto",
      "name": "Molinetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "cdd11e66": [{
      "hkey": "3d1feb0b",
      "slug": "molinetto",
      "name": "Molinetto",
      "primary": true,
      "skipSearch": false
    }],
    "molinetto-via-villetta": [{
      "hkey": "3d1feb0b",
      "slug": "molinetto",
      "name": "Molinetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "fb8ad623": [{
      "hkey": "8422c803",
      "slug": "cittadella-mariano-montebello",
      "name": "Cittadella-Mariano-Montebello",
      "primary": true,
      "skipSearch": false
    }],
    "montebello": [{
      "hkey": "8422c803",
      "slug": "cittadella-mariano-montebello",
      "name": "Cittadella-Mariano-Montebello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "80a3690f": [{
      "hkey": "33fdc294",
      "slug": "ospedale-pablo-prati-bocchi",
      "name": "Ospedale-Pablo-Prati Bocchi",
      "primary": true,
      "skipSearch": false
    }],
    "pablo": [{
      "hkey": "33fdc294",
      "slug": "ospedale-pablo-prati-bocchi",
      "name": "Ospedale-Pablo-Prati Bocchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "77ebd156": [{
      "hkey": "f4cab21b",
      "slug": "paradigna-quartiere-s-p-i-p",
      "name": "Paradigna-Quartiere S.P.I.P.",
      "primary": true,
      "skipSearch": false
    }],
    "paradigna": [{
      "hkey": "f4cab21b",
      "slug": "paradigna-quartiere-s-p-i-p",
      "name": "Paradigna-Quartiere S.P.I.P.",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "603b564a": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "parma-centro": [{
      "hkey": "ae5f9696",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "71222c27": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "pedrignano": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6adc189": [{
      "hkey": "33fdc294",
      "slug": "ospedale-pablo-prati-bocchi",
      "name": "Ospedale-Pablo-Prati Bocchi",
      "primary": true,
      "skipSearch": false
    }],
    "prati-bocchi-osp-maggiore": [{
      "hkey": "33fdc294",
      "slug": "ospedale-pablo-prati-bocchi",
      "name": "Ospedale-Pablo-Prati Bocchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "24785864": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "quartiere-manara": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19b8aad6": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "ravadese": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f73814d8": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "skipSearch": false
    }],
    "s-lazzaro-lubiana": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e3e0eb55": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "skipSearch": false
    }],
    "s-lazzaro-via-parigi": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "ff421f21": [{
      "hkey": "9bc7686e",
      "slug": "san-leonardo-stazione",
      "name": "San Leonardo-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "s-leonardo-stazione-ferrovia": [{
      "hkey": "9bc7686e",
      "slug": "san-leonardo-stazione",
      "name": "San Leonardo-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e29bc8bc": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "skipSearch": false
    }],
    "san-lazzaro": [{
      "hkey": "a96c5275",
      "slug": "san-lazzaro-lubiana",
      "name": "San Lazzaro-Lubiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "55fb58d1": [{
      "hkey": "9bc7686e",
      "slug": "san-leonardo-stazione",
      "name": "San Leonardo-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "9bc7686e",
      "slug": "san-leonardo-stazione",
      "name": "San Leonardo-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "parma"
    }],
    "a1b147f1": [{
      "hkey": "49a638f6",
      "slug": "san-prospero-il-moro",
      "name": "San Prospero-Il Moro",
      "primary": true,
      "skipSearch": false
    }],
    "san-prospero-parmense": [{
      "hkey": "49a638f6",
      "slug": "san-prospero-il-moro",
      "name": "San Prospero-Il Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b3e58ef6": [{
      "hkey": "d06d8906",
      "slug": "campus",
      "name": "Campus",
      "primary": true,
      "skipSearch": false
    }],
    "santa-elisabetta": [{
      "hkey": "d06d8906",
      "slug": "campus",
      "name": "Campus",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7c724e1": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "ugozzolo": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "96bb21e6": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "skipSearch": false
    }],
    "valera": [{
      "hkey": "36869865",
      "slug": "parma",
      "name": "Parma",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dab81ff2": [{
      "hkey": "21e47a48",
      "slug": "corcagnano",
      "name": "Corcagnano",
      "primary": true,
      "skipSearch": false
    }],
    "vigatto-fraz-corcagnano": [{
      "hkey": "21e47a48",
      "slug": "corcagnano",
      "name": "Corcagnano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;